import {Common} from './js/common.js';
import {Faq} from './js/faq.js';
// import文を使ってSassファイルを読み込む。
import "../sass/style.scss";

import smoothscroll from 'smoothscroll-polyfill';


class CAPO {

  constructor() {
    this.common = new Common();
    smoothscroll.polyfill();
    this.dom_loaded();

    // faq page only
    if(document.URL.match(/faq/)){
      this.faq = new Faq();
    }
  }

  dom_loaded() {
    // ページ内のすべてのデータの読み込みが完了したときに実行
    window.addEventListener('load', function () {
      // ヘッダーナビの設定
      capo.common.init_header_nav();

      // スムーズスクロール
      capo.common.set_smooth_scroll();
    });
  }

}

window.capo = new CAPO();